<template>
  <div :class="['flex items-center justify-between p-1', { 'price-disabled': isNotAllowedSelect }]">
    <div class="flex items-center">
      <img 
        v-if="showCheckbox"
        :src="prefix[prefixStyle]" 
        alt="prefix" 
        :class="[
        'prefix', 
        { 'not-allowed-prefix': isNotAllowedSelect }
        ]"
      >
      <p class="ml-2 name">{{ getItemNameByLanguage(testNode.value) }}</p>
    </div>
    <div v-if="showPrice">
      <el-tooltip
        v-if="showAgeRestriction"
        effect="dark"
        content="Only available for patients aged 15 and older."
        placement="top"
        popper-class="custom-tooltip"
        :append-to-body="true"
      >
        <div class="age-restriction">15+</div>
      </el-tooltip>
      <p v-else class="price">{{ currency.symbol + price }}</p>
    </div>
  </div>
</template>

<script>
import { getAllDescendants } from '@/utils/va-order-test/testAndPanelSelection/testSelection';
import { getItemNameByLanguage, getTestCardPrefix } from '@/views/va-orderTest/order-page/order-test-panel/order-test-tabs/testCard.js';
import { mapState } from 'vuex';
export default {
  props: {
    testNode: {
      type: Object,
      default: () => {}
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    isNotAllowedSelect: {
      type: Boolean,
      default: false
    },
    showAgeRestriction: {
      type: Boolean,
      default: false
    },
    selectedVwTestPrice: {
      type: Number,
      default: 0
    },
    showCheckbox: {
      type: Boolean,
      default: true
    },
    showPrice: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      prefix: {
        unCheck: require("@/assets/orderTest/check_box_outline_blank_24px.svg"),
        partCheck: require("@/assets/orderTest/checkbox_indeterminate_box.svg"),
        allCheck: require("@/assets/orderTest/Checkbox(all).svg")
      } 
    }
  },
  computed: {
    ...mapState(["currency", "language"]),
    prefixStyle() {
      let descendants = [];
      getAllDescendants(this.testNode, descendants);
      let prefix = getTestCardPrefix(this.testNode, descendants, this.selectProp);
      return prefix === "partCheck" ? "unCheck" : prefix;
    },
    price() {
      return this.testNode.value.price;
    }
  },
  methods: {
    getItemNameByLanguage(item) {
      return getItemNameByLanguage(item, this.language);
    }
  }
}
</script>

<style scoped>
.not-allowed-prefix {
  opacity: 0.4;
}

.prefix {
  width: 16px;
  height: 16px;
}

.name {
  max-width: 175px;
}

.price {
  /* font-family: IBM Plex Sans Hebrew; */
  font-size: 12px;
  font-weight: 400;
  line-height: 15.6px;
}

.price-disabled {
  color: #979797;
}

.age-restriction {
  width: 36px;
  height: 16px;
  gap: 10px;
  border-radius: 17px;
  border: 1.5px;
  background-color: #DA1E28;
  border-color: #BA0101;
  /* font-family: IBM Plex Sans Hebrew; */
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  color: #FFFFFF;
  cursor: not-allowed; 
  pointer-events: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.age-restriction:active {
  pointer-events: none; 
}
</style>

<style>
.custom-tooltip {
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 9px !important;   
  padding: 12px !important;
  border-radius: 4px !important;
  background: rgba(74, 74, 74, 0.8) !important;
  color: #FFF !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  width: 228px !important;
  border: none !important;
  box-shadow: none !important;
}

.custom-tooltip .el-popper__arrow {
  position: absolute !important;
  bottom: -12px !important; 
  left: 50% !important;
  transform: translateX(-50%) rotate(0deg) !important;
  width: 12px !important;
  height: 12px !important;
  background: rgba(74, 74, 74, 0.8) !important; 
  clip-path: polygon(0% 0%, 100% 0%, 50% 100%) !important; 
}

.custom-tooltip .el-popper__arrow::before {
  display: none !important;
  content: none !important;
} 
</style>